import { LocalizedTextDTO } from 'src/app/models/product-models/DTOs/LocalizedTextDTO';
import { LocalizedText } from 'src/app/models/product-models/views/LocalizedText';

export class Step {
  public static copy(step: Step) {
    return new Step(
      step.id,
      step.steps,
      step.name,
      step.stepId,
      step.navigationPath,
      step.componentClassName,
      step.requiredDatas,
      step.canMatch,
      step.data,
    );
  }

  public static fromDTO(stepDTO: StepDTO): Step {
    return new Step(
      stepDTO.id?.toString(),
      stepDTO.steps.map((stepDTO) => Step.fromDTO(stepDTO)),
      stepDTO.name ? stepDTO.name.map((name) => LocalizedText.fromDTO(name)) : null,
      stepDTO.stepId,
      stepDTO.navigationPath,
      stepDTO.componentClassName,
      stepDTO.requiredDatas,
      stepDTO.canMatch,
      stepDTO.stepData,
    );
  }

  public id?: string;

  public steps: Step[];
  public name: LocalizedText[] | null;
  public navigationPath: string;
  public stepId?: string;
  public componentClassName: string;
  public requiredDatas: string[];
  public canMatch: string[];
  public data?: string;

  constructor(
    id: string | undefined,
    steps: Step[],
    name: LocalizedText[] | null,
    stepId: string | undefined,
    navigationPath: string,
    moduleClassName: string,
    requiredDatas: string[],
    canMatch: string[] = [],
    data?: string,
  ) {
    this.id = id;
    this.steps = steps;
    this.name = name;
    this.stepId = stepId;
    this.navigationPath = navigationPath;
    this.componentClassName = moduleClassName;
    this.requiredDatas = requiredDatas;
    this.canMatch = canMatch;
    this.data = data;
  }
}

export class StepDTO {
  public id?: number;

  public steps: StepDTO[];
  public name: LocalizedTextDTO[] | null;
  public navigationPath: string;
  public stepId?: string;
  public componentClassName: string;
  public requiredDatas: string[];
  public canMatch: string[];
  public stepData?: string;

  constructor(
    id: number | undefined,
    steps: StepDTO[],
    name: LocalizedTextDTO[] | null,
    stepId: string | undefined,
    navigationPath: string,
    moduleClassName: string,
    requiredDatas: string[],
    canMatch: string[] = [],
    data?: string,
  ) {
    this.id = id;
    this.steps = steps;
    this.name = name;
    this.stepId = stepId;
    this.navigationPath = navigationPath;
    this.componentClassName = moduleClassName;
    this.requiredDatas = requiredDatas;
    this.canMatch = canMatch;
    this.stepData = data;
  }
}
